import { fetchData } from './handleApiRequest'

const fetchTeaserList = (url, params, successCallback, errorCallback, finalCallback = () => {}) => {
  const { type, tags, offset, limit } = params

  let requestUrl = url
    .replace('%TYPE%', type)
    .replace('%TAGS%', tags)
    .replace('%OFFSET%', offset)
    .replace('%LIMIT%', limit)

  fetchData({ url: requestUrl })
    .then((response) => {
      if (!Array.isArray(response.elements)) {
        errorCallback()
      }

      successCallback(response.elements)
    })
    .catch(() => {
      errorCallback()
    })
    .finally(() => {
      finalCallback()
    })
}

export { fetchTeaserList }
